<template>
    <div>
        <div v-if="!data" class="text-center" style="padding:100px;">
            <spinner/> {{translate('processingMessages.remLoading')}}
        </div>
        <template v-else>
            <div class="roundbox" style="overflow:hidden;">
                <div class="rbcontent head">
                    <div>
                        <h2>{{data.Subject}}</h2>
                        
                        <table style="margin-top:16px;" class="table table-borderless table-sm ozet">
                            <tbody>
                                <tr>
                                    <td>{{translate('remPreview.sender')}}</td>
                                    <td>:</td>
                                    <td><b>{{data.From.Address}}</b> <span style="margin-left:16px;">{{data.From.Name}}</span></td>
                                </tr>
                                <tr>
                                    <td>{{translate('remPreview.receiver')}}</td>
                                    <td>:</td>
                                    <td>
                                        <div v-for="t in data.To" :key="t.Address">{{t.Address}}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{translate('remPreview.date')}}</td>
                                    <td>:</td>
                                    <td>{{data.Date | datetime}}</td>
                                </tr>
                                <tr>
                                    <td>{{translate('remPreview.messageType')}}</td>
                                    <td>:</td>
                                    <td>{{data.IletiTip}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <small class="text-muted rembox-body">
                            <div v-if="data.IsBodyHtml" v-html="data.Body"></div>
                            <div v-else>{{data.Body}}</div>
                        </small>
                    </div>
                </div>
                <div class="rbcontent">
                    <b>{{translate('draftEyp.attachments')}}</b>
                </div>
                <div class="table-container">
                    <table class="table table-borderless table-hover table-sm">
                        <tbody v-if="data.AttachedMimeMessage">
                            <tr v-for="d in data.AttachedMimeMessage.Attachments" :key="d.id" >
                                <td>
                                    <!-- <a href="#void" @click="downloadAttachment(d)">{{d.FileName}}</a> -->
                                    <file-download-link  :isActive="!data.isArchived" :document="d" @download="downloadAttachment" @preview="showFilePreview"></file-download-link>
                                </td>
                                <td class="text-muted text-right" style="white-space:pre">{{d.Size | prettyBytes}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="d in data.Attachments" :key="d.id" >
                                <td>
                                    <a href="#void" @click="downloadAttachment(d)">{{d.FileName}}</a>
                                </td>
                                <td class="text-muted text-right" style="white-space:pre">{{d.Size | prettyBytes}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="rbcontent form rembox-body" v-if="data.AttachedMimeMessage">
                    <div v-if="data.AttachedMimeMessage.IsBodyHtml" v-html="data.AttachedMimeMessage.Body"></div>
                    <div v-else>{{data.AttachedMimeMessage.Body}}</div>
                </div>

            </div>
            <div v-if="data.Type == 'Outgoing'" class="roundbox" style="margin-top:30px; overflow:hidden;">
                <div class="rbcontent">
                    <h3>{{translate('evidences.evidences')}}</h3>
                </div>
                <div class="table-container">
                    <evidence-list :evidences="data.Evidences" />
                </div>
            </div>
        </template>
        <div style="position:relative; display: block; z-index: 999999;">
            <file-preview v-if="fileDetail" :file="fileDetail" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
        </div>
        
    </div>
   
</template>

<script>
import formMixin from '../formMixin.js';
import evidenceList from '@/components/EvidenceList.vue'
import spinner from '@/components/Spinner.vue'
import fileDownloadLink from '../components/FileDownloadLink.vue'
import filePreview from '../components/FilePreview.vue';
import axios from 'axios'
//import formContainer from '../components/FormContainer.vue'


export default {
    mixins: [formMixin],
    components: {
        spinner,
        evidenceList,
        fileDownloadLink,
        filePreview
    },
    
    created(){
        this.getData(this.$route.params.id, true, this.$route.query.kind);
    },
    data() {
        return {
            loading: false,
            modelName: 'RemBox',
            data: null,
            fileDetail: null,           // Önizlemesi görüntülenecek dosya

        }
    },
    methods: {
        loadMessage(){

        },
        showFilePreview(document, type) {
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.EntityType = "Rem";
        },
        downloadAttachment(attachment, menuKey){
            // İndirilecek ek dosya için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/rembox/createAttachmentUrl/`, {
                  EntityId : this.data.Id,
                  AttachmentId: attachment.Id
              })
              .then(x => {
                console.log("createAttachmentUrl Result:", x.data);
                window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => {
                  switch(x.response.status) {
                      case 404:
                        alert(this.translate('errors.noRecord'));
                        break;
                    default:
                        this.errorMessage = this.translate('errors.processFailed') + x;
                        break;
                  }
                  this.loading = false;
              });
        },
    }
}
</script>
<style scoped>

</style>